import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { IoSearch, IoCart } from "react-icons/io5";
import { Link } from "react-router";
import useCart from '@/hooks/useCart';
import { PATHS } from '@/navigation/paths';
import { buildSearchUrl } from '@/hooks/useSearchFilters';
import HomeAppStoreBadge from "./HomeAppStoreBadge";
import HeaderBlogLink from "./HeaderBlogLink";

/**
 * HeaderMenuPublic - Header menu for logged-out users.
 * Shows search, cart, and login/signup buttons.
 * Does NOT make any authenticated API calls.
 */
const HeaderMenuPublic = () => {
  // Cart hook for displaying cart count (works for guests too)
  const { totalQuantity, isLoading: isCartLoading } = useCart();

  // Track previous quantity for bounce animation (using state instead of ref)
  const [prevQuantity, setPrevQuantity] = useState(totalQuantity);
  const [shouldBounce, setShouldBounce] = useState(false);

  // Detect quantity increase during render and trigger bounce
  if (!isCartLoading && totalQuantity !== prevQuantity) {
    if (totalQuantity > prevQuantity) {
      setShouldBounce(true);
    }
    setPrevQuantity(totalQuantity);
  }

  // Clear bounce animation after duration
  useEffect(() => {
    if (!shouldBounce) return;
    const timer = setTimeout(() => setShouldBounce(false), 700);
    return () => clearTimeout(timer);
  }, [shouldBounce]);

  return (
    <div className="headerBlock">
      <HomeAppStoreBadge />
      <div className="navSearch">
        <Link to={buildSearchUrl({ view: 'map' })} replace>
          <IoSearch />
        </Link>
        <HeaderBlogLink />
        {/* Search and the blog sit before the line, the cart after it, as in the signed-in header (Tyler, 2026-10-27). */}
        <span className="divider"></span>
        <Link to={PATHS.cart} className="cardPos">
          <IoCart />
          {!isCartLoading && totalQuantity > 0 && (
            <span className={`count${shouldBounce ? ' cart-bump' : ''}`}>
              {totalQuantity > 99 ? "99+" : totalQuantity}
            </span>
          )}
        </Link>
      </div>

      {/* The login and signup pages render outside RootLayout, so this
          header never shows on them and needs no path check to hide itself. */}
      <div className="btnBox">
        <Button variant="login-header" as={Link} to={PATHS.login} size="sm">
          Login
        </Button>
        <Button variant="signup-header" as={Link} to={PATHS.signup} size="sm">
          Sign Up
        </Button>
      </div>
    </div>
  );
};

export default HeaderMenuPublic;
